import { createFileRoute, redirect } from '@tanstack/react-router';
import { TabbedPageLayout, type RoutedTab } from '@/components/tabbed-page-layout';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute('/_auth/_side-layout/settings_/privacy')({
  component: () => (
    <TabbedPageLayout
      title="Privacy"
      isNew
      description="Manage how Logspot resolves consent and handle GDPR/CCPA data-subject requests for your organization."
      tabs={TABS}
    />
  ),
  beforeLoad: async ({ context }) => {
    // Org owner/admin capability (org-scoped). Not platform/super-admin.
    if (!hasPermission(context.userRole, { organization: ['update'] })) {
      throw redirect({ to: '/' });
    }
  },
});

const TABS: RoutedTab[] = [
  { to: '/settings/privacy/user-consent', label: 'User Consent' },
  { to: '/settings/privacy/consent-sources', label: 'Consent Sources' },
  { to: '/settings/privacy/server-events', label: 'Server Events' },
  { to: '/settings/privacy/requests', label: 'Privacy Requests' },
];
